import { render } from "./TSATopBar.vue?vue&type=template&id=31fe8639&scoped=true"
import script from "./TSATopBar.vue?vue&type=script&lang=js"
export * from "./TSATopBar.vue?vue&type=script&lang=js"

import "./TSATopBar.vue?vue&type=style&index=0&id=31fe8639&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fe8639"]])

export default __exports__